import React, { useCallback, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import _isEmpty from 'lodash/isEmpty';

import { formatCurrency } from '@atc/string-fns';
import { calculateDownPayment, getInterestRate } from '@atc/wallet-payment-fns';

import { Button } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { snapshotPaymentDetailsClick } from 'reaxl-analytics-handlers';

import {
    paymentsDuck,
    preorderDuck,
} from '@/ducks';

import PaymentCalculationFetcher from '@/fetchers/PaymentCalculationFetcher';

export const BuildAndPricePaymentContainer = React.memo(({
    nationalMSRP = 0,
}) => {
    const dispatch = useDispatch();
    const [monthlyPayment, setMonthlyPayment] = useState(0);
    const preorderListings = useSelector(preorderDuck.selectors.getPreorder) || [];
    const listing = preorderListings.find((item) => item.id === 'preorderBAP') || {};
    const listingId = listing.id || '';

    const payments = useSelector(paymentsDuck.selectors.getPaymentsInfo) || {};
    const penciling = useSelector(paymentsDuck.selectors.getPencilingValues) || {};
    const paymentsInfo = Object.assign(payments, penciling);

    const getMonthlyBudget = useCallback(async () => {
        const { loanTerm, interestRate, tradeIn, creditType } = paymentsInfo;

        const downPaymentParam = calculateDownPayment(nationalMSRP, paymentsInfo);
        const interestRateParam = getInterestRate(interestRate, 'new');
        const tradeInParam = tradeIn?.value || 0;
        const amountOwedParam = tradeIn?.amountOwed || 0;

        const paymentParams = `budget=${nationalMSRP}&terms=${loanTerm}&customRate=${interestRateParam}&downPayment=${downPaymentParam}&tradeInValue=${tradeInParam}&amountOwed=${amountOwedParam}&creditRange=${creditType}`;

        const paymentDetails = await PaymentCalculationFetcher(paymentParams);

        setMonthlyPayment(paymentDetails?.rates?.[creditType]?.custom?.[loanTerm]?.[0]?.payment);

    }, [nationalMSRP, paymentsInfo]);

    const handlePaymentClick = useCallback((event) => {
        const extra = {
            inventoryId: listingId,
            par: 'buildAndPrice',
        };
        sendClick(snapshotPaymentDetailsClick, event, extra);

        dispatch(paymentsDuck.creators.updateMyWallet({
            listingId,
            showPaymentDetailsModal: true,
        }));
    }, [dispatch, listingId]);

    useEffect(() => {
        getMonthlyBudget();
    }, [getMonthlyBudget]);

    if (!_isEmpty(paymentsInfo)) {
        return (
            <span
                className="text-size-500"
                data-cmp="lnk-pymt"
            >
                <span className="margin-horizontal-2">|</span>
                <Button
                    onClick={handlePaymentClick}
                    bsStyle="text-decorated"
                >
                    {formatCurrency(Math.floor(monthlyPayment))}
                    /mo.
                </Button>
                <span className="text-size-400 text-subdued margin-left-1">est. payment</span>
            </span>
        );
    }

    return null;

});

export default BuildAndPricePaymentContainer;
